<template>
  <intro-container>
    <div
      class="
        d-flex
        justify-center
        align-center
        fill-height
        login__form-container
      "
    >
      <v-snackbar
        :timeout="0"
        v-model="snackbar"
        color="error"
        top
        absolute
        centered
      >
        <p>{{ $t("login.form.error.incorrect") }}</p>
        <v-icon class="snackbar-icon" @click="snackbar = false">
          $iconClose
        </v-icon>
      </v-snackbar>
      <div class="login__form pr-3">
        <h1 class="mb-6">{{ $t("login.form.title") }}</h1>
        <v-form
          ref="loginForm"
          v-model="valid"
          @submit.prevent="startLogin"
          lazy-validation
        >
          <v-subheader class="mb-2 ml-0 pl-0" style="height: auto">
            {{ $t("login.form.email") }}
          </v-subheader>
          <v-text-field
            v-model="email"
            :placeholder="$t('login.form.email')"
            :rules="[
              (v) => !!v || $t('login.form.error.required'),
              error ? $t('login.form.error.incorrect') : true,
            ]"
            required
            hide-details
            rounded
            outlined
            filled
          />
          <v-subheader class="mb-2 mt-4 ml-0 pl-0" style="height: auto">
            {{ $t("login.form.password") }}
          </v-subheader>
          <v-text-field
            v-model="password"
            class="mb-6"
            :placeholder="$t('login.form.password')"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? '$iconEyeHide' : '$iconEyeShow'"
            @click:append="showPassword = !showPassword"
            :rules="[
              (v) => !!v || $t('login.form.error.required'),
              error ? $t('login.form.error.incorrect') : true,
            ]"
            :hide-details="valid"
            required
            rounded
            outlined
            filled
          />
          <div class="login__forgot-password body2">
            <router-link to="/password-reset">
              {{ $t("login.reset_password") }}
            </router-link>
          </div>
          <niko-button
            :text="$t('login.form.button')"
            width="100%"
            class="mt-12"
            type="submit"
            primary
          />
          <niko-button
            :text="$t('login.form.signup')"
            width="100%"
            class="mt-8"
            type="button"
            to="/signup"
          />
        </v-form>
      </div>
    </div>
  </intro-container>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import NikoButton from "@/components/UI/NikoButton";
import IntroContainer from "@/components/IntroContainer";

export default {
  name: "login",
  components: {
    NikoButton,
    IntroContainer,
  },
  data: () => ({
    valid: true,
    snackbar: false,
    showPassword: false,
    email: "",
    password: "",
  }),
  computed: {
    ...mapState("authStore", ["error"]),
  },
  methods: {
    ...mapActions("authStore", ["login", "resendConfirmationCode"]),
    ...mapMutations("authStore", [
      "setError",
      "setUserConfirmed",
      "setSignupDone",
    ]),
    startLogin() {
      if (this.$refs.loginForm.validate()) {
        this.login({
          email: this.email.toLowerCase(),
          password: this.password,
        });
      }
    },
  },
  watch: {
    email() {
      if (this.error) {
        this.setError(null);
      }
    },
    password() {
      if (this.error) {
        this.setError(null);
      }
    },
    error(value) {
      if (value.name === "UserNotConfirmedException") {
        this.setSignupDone(true);
        this.resendConfirmationCode(this.email.toLowerCase());
        this.$router.push("/signup");
      } else {
        this.snackbar = !!value;
      }
    },
  },
  created() {
    this.setUserConfirmed(false);
    this.setSignupDone(false);
  },
};
</script>

<style lang="scss">
.login {
  overflow: auto;

  &__row {
    min-height: 500px;
  }

  &__form-container {
    position: relative;
  }

  &__form {
    flex-basis: 380px;
  }

  &__forgot-password {
    text-align: right;
  }
}

.v-text-field--enclosed .v-input__append-inner {
  margin-top: 8px;
}

.v-text-field__details {
  padding-left: 0 !important;
}

.v-input.error--text:before {
  content: "";
  height: calc(100% + 20px);
  width: 4px;
  background: var(--v-error-base);
  position: absolute;
  left: -12px;
  top: -24px;
}

.v-input--hide-details.error--text:before {
  height: 70px;
}

.snackbar-icon {
  width: 16px !important;
  height: 16px;
}
</style>
